import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { UnsavedChangesProvider } from './data/analiseContext';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <UnsavedChangesProvider>
      <App />
    </UnsavedChangesProvider>
  </React.StrictMode>
);
